import { useEffect } from 'react';

import { postRequest } from '../../services/api';

import type { KycInitiationTrigger } from './types';

export function useKycImpressionReport(trigger: KycInitiationTrigger, isHidden?: boolean) {
  const shouldReport = !isHidden;

  useEffect(() => {
    if (shouldReport) {
      void postRequest('/v2/kyc/report/impression', { trigger }).catch();
    }
    // Impression should only be reported once
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldReport]);
}
